import { render, staticRenderFns } from "./SearchProfile.vue?vue&type=template&id=458debc7&scoped=true"
import script from "./SearchProfile.vue?vue&type=script&lang=js"
export * from "./SearchProfile.vue?vue&type=script&lang=js"
import style0 from "./SearchProfile.vue?vue&type=style&index=0&id=458debc7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458debc7",
  null
  
)

export default component.exports